import React from "react";
import ContactoComponent from "../components/home/ContactoComponent";

const Contacto = () => {
  return <ContactoComponent />;
};

export default Contacto;
